import React from 'react';
import Button from '../../Button';
import Col from '../../Col';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import Row from '../../Row';
import { variables } from 'src/Tenants';
import {
  useServiceRequestFormQuestionOrchestrator,
  UseServiceRequestFormQuestionOrchestratorReturn,
} from './useServiceRequestFormQuestionOrchestrator';
import './ServiceRequestFormQuestion.scss';

const ServiceRequestFormQuestion = () => {
  const {
    faq,
    onProceed,
    onBack,
    onExit,
  }: UseServiceRequestFormQuestionOrchestratorReturn =
    useServiceRequestFormQuestionOrchestrator();

  return (
    <ServiceRequestFormDialog
      title={faq.caption}
      onBack={onBack}
      onExit={onExit}
      footer={
        <>
          <span className="sr-form-question__resolution-prompt">
            Did this help you resolve the issue?
          </span>
          <Button
            color="teal"
            size="small"
            label="Yes, Return to Dashboard"
            onClick={onExit}
          />
          <Button
            color="teal"
            size="small"
            label={`No, Submit ${variables.serviceRequest}`}
            onClick={onProceed}
          />
        </>
      }
    >
      <Row mdCenter>
        <Col xs="12" md="6">
          <div className="sr-form-question__photo">
            <a href={faq.image} target="_blank" rel="noreferrer">
              <img src={faq.image} alt="" />
            </a>
          </div>
          <div className="sr-form-question__body">{faq.linkTitle}</div>
        </Col>
      </Row>
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormQuestion;